/**
 * WHAT A CELL SHOWS WHEN THE ROW STATES NOTHING — one marker for the whole
 * product, defined once so that changing it is one edit and not a sweep.
 *
 * TODAY IT IS EMPTY, and that is a decision rather than an omission. A registry
 * of nine files with "Not uploaded" written down seven of them is a column of
 * noise a reader has to look past to find the two rows that say something; the
 * absence already reads as an absence. Two surfaces had each reached for their
 * own em dash by hand before this existed, which is how a product ends up with
 * three different ways of saying nothing.
 *
 * THE FUNNEL IS WHAT MAKES A BLANK CELL SAFE. A column that renders this marker
 * returns `null` — or an empty list — from its filter `values` for the same
 * row, and the shared table offers those rows as `Not set`: one entry with its
 * own count, ticked like any other value. The cell says nothing and the funnel
 * says it once. Answering with nothing at all — which this used to require —
 * made those rows unreachable from their own column: they matched no criterion,
 * appeared under no tick, and the only way to see them alone was to narrow
 * every other column until they were what was left.
 *
 * IT IS NOT FOR A STATE THE PRODUCT NAMED. "Not started", "Not linked", "Not
 * detected", "Follow current" are facts a row asserts, not values it lacks, and
 * blanking them would delete information the reader needs. Those stay worded
 * and become their own checklist entry. This is only for a column that has
 * nothing to say about this row.
 */
export function EmptyValue() {
  return null
}
